import { render, staticRenderFns } from "./WithdrawalOptionManagement.vue?vue&type=template&id=66c2127a&scoped=true"
import script from "./WithdrawalOptionManagement.vue?vue&type=script&lang=js"
export * from "./WithdrawalOptionManagement.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalOptionManagement.vue?vue&type=style&index=0&id=66c2127a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2127a",
  null
  
)

export default component.exports